import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { loginUser, clearError } from '../redux/slices/authSlice';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
//import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import loginImage from '../../src/assets/images/all/login.png';
import '../../src/assets/css/bootstrap.min.css';
import '../../src/assets/css/fontawesome-all.min.css';
import '../../src/assets/css/slick.css';
import '../../src/assets/css/line-awesome.min.css';
// import '../../src/assets/css/main.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, successMessage } = useSelector((state) => state.auth);
  // const { loading, error, successMessage } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  // const [error, setError] = useState({});
  const [state, setState] = useState({
      email: '',
    });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Form submitted! Email:", state.email);

    if (!state.email) {
        console.error("Email is empty!");
        setMessage("Email is required!");
        return;
    }

    try {
        console.log("Sending request to:", `${API_BASE_URL}/forgot-password`);
        
        const response = await axios.post(`${API_BASE_URL}/forgot-password`, { email: state.email });

        console.log("Response received:", response.data); // Add `.data`
        setMessage(response.data.message);
    } catch (error) {
        console.error("Request failed:", error);
        setMessage("Something went wrong.");
    }
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // setMessage("");
  //   console.log("Email:", state.email);
  //   try {
  //     console.log("Email:", state.email);
  //     const response = await axios.post(`${API_BASE_URL}/forgot-password`, { email: state.email });
  //     console.log("Response received:", response);
  //     setMessage(response.data.message);
  //   } catch (errors) {
  //     setMessage("Something went wrong.");
  //   }
  // };


  // const validateForm = (data) => {
  //   const errors = {};
  //   if (!data.email.trim()) {
  //     errors.email = 'Email is required';
  //   } else if (!/\S+@\S+\.\S+/.test(data.email)) {
  //     errors.email = 'Email is invalid';
  //   }
  //   return errors;
  // };

  return (
    <section className="account d-flex" style={{ height: '100vh' }}>
  <div className="account__left d-none d-md-flex position-relative overflow-hidden">
    <img
      src={loginImage}
      alt="Login"
      className="account__img position-absolute w-100 h-100 object-cover"
    />
  </div>

  <div className="account__right pt-5 flx-align d-flex justify-content-center align-items-center">
    <div className="account-content">
      <h2 className="login-heading font-heading text-end mb-4">Forgot password</h2>
      <form onSubmit={handleSubmit}>
        <div className="row gy-3">
          <div className="col-12">
            <label htmlFor="email" className="form-label mb-2 font-18 font-heading fw-600">
              Email
            </label>
            <input
                  type="email"
                  className="common-input common-input--bg"
                  id="email"
                  placeholder="name@example.com"
                  value={state.email}
                  onChange={handleChange}
                />
            
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="col-12">
            <button
              disabled={loading}
              type="submit"
              className="btn btn-main btn-lg w-100 pill"
            >
              {loading ? 'Loading...' : 'Forgot password'}
            </button>
            {errors.general && <span className="error-message">{errors.general}</span>}
            <span className="success-message">{message}</span>
          </div>
        </div>
      </form>

      <div className="col-sm-12 mb-3 mt-3">
        <p className="text font-14 text-center">Or</p>
      </div>

      <div className="col-sm-12 mt-3">
        <p className="text font-14 text-center">
          <Link to="/login" className="link text-main text-decoration-underline fw-500">
            Login
          </Link>
        </p>
        <p className="text font-14 text-center">
          <Link to="/register" className="link text-main text-decoration-underline fw-500">
            Create Account
          </Link>
        </p>
      </div>
    </div>
  </div>
</section>
  );
};

export default ForgotPassword;
